<template>
  <div>
    <div>
      <div class="text-left">
        <h5 v-if="dataProps.label">{{ dataProps.label | token_replace(nid) }}</h5>
        <p>{{ dataProps.helptext | token_replace(nid) }}</p>
      </div>
      <md-content class="text-left upload-link">
        <md-button class="md-primary" @click="showLinkDialog = true">
          <md-icon>link</md-icon>
          <span>Add Link</span>
        </md-button>
        <md-button @click="openPicker" class="md-primary">
          <md-icon>cloud_upload</md-icon>
          <span>Upload File</span>
        </md-button>
        <input style="display:none" type="file" ref="inputFile" @change="onChange" />
      </md-content>
      <md-field :class="classMessage" class="no-height">
        <span class="md-error">*Required.</span>
      </md-field>
    </div>
    <md-dialog :md-active.sync="showLinkDialog">
      <md-dialog-title>Add Web Link</md-dialog-title>
      <md-dialog-content>
        <div v-bind:key="val.uuid" v-for="(val, index) in value">
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-field>
                <label>Add Web Link</label>
                <md-input v-model="value[index].link"></md-input>
              </md-field>
            </div>
            <div v-if="value.length - 1 != index" class="md-layout-item delete">
              <div class="controll-icon">
                <md-button @click="del(index)" class="md-icon-button">
                  <md-icon>delete</md-icon>
                </md-button>
              </div>
            </div>
          </div>
        </div>
        <md-button class="add-another" @click="add">Add Another Link</md-button>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="close" @click="cancel">Close</md-button>
        <md-button class="md-primary save" @click="save">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
export default {
  name: "FbFileView",
  props: ["dataProps", "classMessage", "nid"],
  computed: {
    filtered_value() {
      return this.value
        .filter((el) => {
          return el.link && el.link != "";
        })
        .map((el) => {
          if (el.link.match(/^https?:\/\//)) {
            return el.link;
          }
          if (el.link != "") {
            return "http://" + el.link;
          }
        });
    },
  },
  data() {
    return {
      showLinkDialog: false,
      value: [
        {
          uuid: this.$uuid.v1(),
          link: "",
        },
      ],
    };
  },
  methods: {
    readFile(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.addEventListener("loadend", function (e) {
          // reader.result contains the contents of blob as a typed array
          if (!e.target.result) {
            reject();
          }
          resolve(e.target.result);
        });
        if (file != "") {
          reader.readAsArrayBuffer(file);
        } else {
          reject();
        }
      });
    },
    openPicker() {
      this.$refs.inputFile.value = "";
      this.$refs.inputFile.click();
    },
    onChange(event) {
      this.readFile(event.target.files[0]).then((buffer) => {
        this.$emit("update-files", {
          name: event.target.files[0].name,
          buffer: buffer,
        });
      });
      this.$emit("update-error");
    },
    save() {
      this.showLinkDialog = false;

      this.$emit("update-links", this.filtered_value);
      this.value = [
        {
          uuid: this.$uuid.v1(),
          link: "",
        },
      ];
    },
    cancel() {
      this.showLinkDialog = false;
    },
    add() {
      this.value.push({
        uuid: this.$uuid.v1(),
        link: "",
      });
    },
    del(index) {
      this.value.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.md-dialog.md-dialog-fullscreen {
  @media all and (min-width: 600px) {
    width: 50%;
  }
}
.no-height {
  min-height: 1px;
  padding: 0;
  &.md-field.md-theme-default:after {
    display: none;
  }
}
.add-another {
  margin-left: -16px;
}
.delete {
  max-width: 80px;
  @media all and (max-width: $breakpoint-medium) {
    padding-top: 50px;
  }
}
.controll-icon {
  margin: 4px 0 24px;
  padding-top: 8px;
}
.md-dialog-content::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}
.md-dialog-content::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
.md-dialog-actions {
  padding: 0px 20px 20px 20px;
  display: flex;
  justify-content: space-between;
  .md-button.close {
    margin-left: -8px;
  }
}
.upload-link {
  padding: 0;
  .md-button.md-theme-default.md-primary.md-primary {
    margin-left: 0;
    margin-right: 40px;
    color: rgb(60, 60, 60);
    background-color: $blue-light;
    font-size: 14px;
    font-weight: 300;
    .md-icon {
      color: $blue-active;
    }
  }
}
</style>
